module.exports = __webpack_public_path__ + "media/images/browsers/maxthon-3ce4cad6cbf7ae7aa18864c154e51478.svg";